import { Button, Menu, MenuItem } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useLanguageContext } from "./LanguageContext";
import LanguageIcon from "@mui/icons-material/Language";
import Fade from "@mui/material/Fade";
import { useRouter } from "next/router";
export default function SelectLanguageMenuButton() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const lngContext = useLanguageContext();
  const router = useRouter();
  const { t } = useTranslation("common");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const langs = ["zh-TW", "zh-CN", "en-US", "ja-JP", "ko-KR"];
  const langsToString = {
    "zh-TW": "繁體中文",
    "zh-CN": "简体中文",
    "en-US": "English",
    "ja-JP": "日本語",
    "ko-KR": "한국어",
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div id="LanguageSelectionDiv">
      <Button
        aria-label={t("nav-language")}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ minWidth: 0 }}
        color="primary"
        id="LanguageSelectionButton"
      >
        <LanguageIcon style={{ width: 24, paddingRight: 4 }}></LanguageIcon>
        {/* <span id="navBarChangeLanguage"></span>
        留著給自動測試抓 */}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        // getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ top: 14, left: 6 }}
        TransitionComponent={Fade}
      >
        {langs.map((lng) => {
          return (
            <MenuItem
              key={lng}
              onClick={() => {
                lngContext.ChangeLanguege(lng);
                handleClose();
              }}
            >
              <span id={"languageOption_" + lng}>{langsToString[lng]}</span>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
